import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    status: {
      borderRadius: 2,
      color: '#fff',
      fontSize: '12px',
      fontWeight: 500,
      padding: '6px 16px',
      position: 'relative',
    },
    usercancelled: {
      backgroundColor: theme.palette.statuses.cancelled,
    },
    admincancelled: {
      backgroundColor: theme.palette.statuses.cancelled,
    },
    completed: {
      backgroundColor: theme.palette.statuses.completed,
    },
    reserved: {
      backgroundColor: theme.palette.statuses.reserved,
    },
    noshow: {
      backgroundColor: theme.palette.statuses.noshow,
    },
    rejected: {
      backgroundColor: theme.palette.statuses.rejected,
    },
    canceled: {
      backgroundColor: theme.palette.statuses.cancelled,
    },
    pending: {
      backgroundColor: theme.palette.statuses.pending,
    },
    inprogress: {
      backgroundColor: theme.palette.statuses.inProgress,
    },

    vehicleLink: {
      fontSize: '12px',
      fontWeight: 500,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'none',
        fontWeight: 500,
      },
    },
    loadingContainer: {
      height: 150,
      width: '100%',
    },
    location: {
      backgroundColor: '#F9FCFF',
      padding: '24px 16px',
    },
    name: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 500,
      color: theme.palette.text.primary,
    },

    textRight: {
      textAlign: 'right',
    },

    mt10: {
      marginTop: 10,
    },

    mt5: {
      marginTop: 5,
    },

    cardContentPadding: {
      padding: '24px 32px;',
    },

    textSecondary: {
      color: theme.palette.secondary.light,
      lineHeight: 1,
    },
    textPrimary: {
      fontWeight: 'bold',
      textTransform: 'capitalize',
      color: theme.palette.primary.main,
      lineHeight: 1,
    },

    textSubtitle: {
      color: theme.palette.text.subtitle,
    },

    lineHeight: {
      lineHeight: 1,
    },

    list: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      width: '100%',
      alignItems: 'flex-start',
    },

    listItem: {
      width: '100%',
      padding: '0 4px 8px 0',
      '&:not(:last-of-type)': {
        borderBottom: `1px solid ${theme.palette.common.greyLight}`,
      },
    },
    zoneLine: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      height: '100%',
      left: 0,
      position: 'absolute',
      top: 6,
      width: 20,
    },
    circle: {
      backgroundColor: theme.palette.primary.main,
      borderRadius: '100%',
      minHeight: 9,
      minWidth: 9,
    },
    dashedLine: {
      backgroundColor: '#fff',
      border: 'none',
      borderLeft: `1px dashed ${theme.palette.primary.main}`,
      color: '#fff',
      height: 'calc(100% - 3px)',
      margin: '2px 0',
      width: 1,
    },
    locationLineContainer: {
      top: 2,
    },
    locationIcon: {
      color: theme.palette.primary.main,
      fontSize: theme.typography.pxToRem(16),
    },
    timezone: {
      display: 'block',
      color: theme.palette.secondary.light,
    },
  };
});

const customCardStyles = makeStyles((theme) => {
  return {
    root: {
      padding: 0,
      paddingBottom: '0 !important',
    },
  };
});

const collapseCardStyles = makeStyles({
  root: {
    marginTop: 20,
    marginBottom: 20,
    '& button': {
      borderRadius: '4px 4px 0 0',
    },
  },
  box: {
    borderTop: 0,
    marginTop: 0,
    borderRadius: '0 0 4px 4px',
    border: '1px solid rgba(0, 0, 0, 0.12)',
  },
  buttonClass: {
    backgroundColor: '#FBFBFB',
    border: '1px solid #EEEEEE',
    boxShadow: 'none',
    color: '#4D4F5C',
    padding: '14px 24px',
    textTransform: 'capitalize',
    fontSize: '13px',
    '&:hover': {
      backgroundColor: '#FBFBFB',
      border: '1px solid #EEEEEE',
      boxShadow: 'none',
      color: '#4D4F5C',
    },
  },
});

const listTextStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    primary: {
      fontSize: '13px',
      fontWeight: 'bold',
      color: '#4D4F5C',
      wordBreak: 'break-word',
    },

    secondary: {
      color: theme.palette.common.lightNavy,
      fontSize: '13px',
      wordBreak: 'break-word',
    },
  };
});

export { useStyles, listTextStyles, customCardStyles, collapseCardStyles };
